import { asScaled } from '../utils';
const pickerLayOut = {
    scrollpickerWrap: {
        left: 0,
        right: 0,
        bottom: 34,
        top: 48
    },
    subTitle: {
        paddingVertical: 8,
        marginHorizontal: 40
    },
    title: {
        paddingVertical: 8
    },
    header: {
        height: 48,
        paddingHorizontal: 12
    },
    headerContent: {
        paddingHorizontal: 20
    },
    datePicker: {
        height: 200
    },
    pickerBtn: {
        padding: 10
    }
};
const pickerLayOutScaled = asScaled(pickerLayOut);
export const picker = {
    scaled: pickerLayOutScaled,
    unscaled: pickerLayOut
};
